document.addEventListener('DOMContentLoaded', () => {
    // Safety check for IntersectionObserver support
    if (!('IntersectionObserver' in window)) {
        console.warn('IntersectionObserver not supported, falling back to immediate load');
        return;
    }

    // Handle Swiper slide changes
    try {
        document.querySelectorAll('.marquee-swiper').forEach(swiperElement => {
            if (swiperElement?.swiper) {
                swiperElement.swiper.on('slideChange', loadAvisImages);
            }
        });
    } catch (err) {
        console.warn('Error setting up Swiper handlers:', err);
    }

    // Enhanced URL change detection for Shopify pagination
    let lastUrl = location.href;

    const handleUrlChange = () => {
        try {
            const currentUrl = location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;
                setTimeout(loadAvisImages, 300);
            }
        } catch (err) {
            console.warn('Error in handleUrlChange:', err);
        }
    };

    // Listen for Shopify's page transitions
    window.addEventListener('popstate', handleUrlChange);

    // Watch for any DOM changes that might indicate pagination
    try {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (!mutation) continue;
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    const currentUrl = location.href;
                    if (currentUrl !== lastUrl) {
                        handleUrlChange();
                    }
                }
            }
        });

        // Observe the document for changes
        observer.observe(document, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['href']
        });
    } catch (err) {
        console.warn('Error setting up MutationObserver:', err);
    }
});